import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { environment } from '../../environments/environment';
import { GlobalListTranslation } from '../models/global-list-translation-data.models';

@Injectable({
  providedIn: 'root'
})
export class GlobalListTranslationDataService {
  constructor(private api: ApiService) {}
  private baseUrl = environment.apiUrl;

  getData(): Observable<GlobalListTranslation[]> {
    return this.api.get(
      `${this.baseUrl}/globallisttranslationdata/translationstatus`);
  }

  
}